import * as Yup from 'yup';

const Form1 = Yup.object({
    jobTitle: Yup.string().required('Job title is required'),
    jobFunction: Yup.string().required('Job function is required'),
    location: Yup.string().required('Location is required'),
})

export default Form1;